import {BS2} from "../../BS2";
import {BS2GameAssets} from "../../BS2GameAssets";
import {gsap} from "gsap";

/**
 * Created by jonas on 2023-01-27.
 */

export class DemonCircles extends PIXI.Container {
    private _innerCircle: PIXI.Sprite;
    private _middleCircle: PIXI.Sprite;
    private _loopAnimation: gsap.core.Timeline;
    private _outerCircleCont: PIXI.Container;

    constructor() {
        super();
        this._outerCircleCont = this.createOuterCircleCont();
        this._innerCircle = this.createCircleSprite(BS2GameAssets.OUTRO_INNER_CIRCLE);
        this._middleCircle = this.createCircleSprite(BS2GameAssets.OUTRO_MIDDLE_CIRCLE);
        this.addChild(this._outerCircleCont);
        this.addChild(this._innerCircle);
        this.addChild(this._middleCircle);
        this.hide(0);
    }

    public show(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.startLoop();
        })
        tl.add(gsap.to(this, {duration: duration, alpha: 1, ease: "none"}));
        return tl;
    }

    public hide(duration: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration: duration, alpha: 0, ease: "none"}));
        tl.add(() => {
            this.stopLoop();
        })
        return tl;
    }

    private createOuterCircleCont(): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container(),
            outerCircleSprite: PIXI.Sprite = this.createCircleSprite(BS2GameAssets.OUTRO_OUTER_CIRCLE, new PIXI.Point(0.5, 0.515));
        cont.addChild(outerCircleSprite);
        cont.name = "outerCircleCont";
        for (let i: number = 0; i < 5; i++) {
            const flame: PIXI.spine.Spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.CANDLE_FLAME_SPINE));
            flame.name = "flame" + (i + 1);
            switch (i) {
                case 0:
                    flame.position.set(0, -343);
                    break;
                case 1:
                    flame.position.set(320, -123);
                    flame.angle = 75;
                    break;
                case 2:
                    flame.position.set(220, 259);
                    flame.angle = 135;
                    break;
                case 3:
                    flame.position.set(-202, 278);
                    flame.angle = 216;
                    break;
                case 4:
                    flame.position.set(-322, -128);
                    flame.angle = -70;
                    break;
            }
            cont.addChild(flame)
        }
        return cont;
    }

    private createCircleSprite(textureName: string, anchor: PIXI.Point = new PIXI.Point(0.5, 0.5)): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(textureName)[0]);
        sprite.name = textureName;
        sprite.anchor = anchor;
        return sprite;
    }

    private startLoop() {
        this._outerCircleCont.children.forEach((ele) => {
            if (ele.name && ele.name.includes("flame")) {
                (ele as PIXI.spine.Spine).state.setAnimation(0, "flame_Loop", true);
            }
        });
        if (!this._loopAnimation) {
            this._loopAnimation = gsap.timeline({repeat: -1});
            this._loopAnimation.add(gsap.to(this._innerCircle, {
                duration: 12,
                rotation: Math.PI * 2,
                ease: "none"
            }));
            this._loopAnimation.add(gsap.to(this._middleCircle, {
                duration: 12,
                rotation: -Math.PI * 2,
                ease: "none"
            }), 0);
            this._loopAnimation.add(gsap.to(this._outerCircleCont, {
                duration: 12,
                rotation: Math.PI * 2,
                ease: "none"
            }), 0);
        }
        this._loopAnimation.play();
    }

    private stopLoop() {
        if (this._loopAnimation) {
            this._loopAnimation.pause();
            this._outerCircleCont.children.forEach((ele) => {
                if (ele.name && ele.name.includes("flame")) {
                    (ele as PIXI.spine.Spine).state.clearTracks();
                    (ele as PIXI.spine.Spine).state.setEmptyAnimation(0, 0);
                    (ele as PIXI.spine.Spine).skeleton.setBonesToSetupPose();
                    (ele as PIXI.spine.Spine).skeleton.setSlotsToSetupPose();
                }
            });
        }
    }
}